<template>
    <div class="row">
        <div class="section">
            <div class="container">
                <div class="slider">
                    <ul class="slides">
                        <li>
                            <img src="../../img/galeriaFotos/resplendor1.jpg"> <!-- random image -->
                            <div class="caption center-align">
                                <h3>Venha para Resplendor!</h3>
                                <h5 class="light grey-text text-lighten-3">Você irá amar!</h5>
                            </div>
                        </li>
                        <li>
                            <img src="../../img/galeriaFotos/resplendor3.jpg"> <!-- random image -->
                            <div class="caption left-align">
                                <h3>Ótimo!</h3>
                                <h5 class="light grey-text text-lighten-3">Lugar de Descanso e Lazer!</h5>
                            </div>
                        </li>
                        <li>
                            <img src="../../img/galeriaFotos/resplendor2.jpg"> <!-- random image -->
                            <div class="caption left-align">
                                <h3>Melhor Lugar!</h3>
                                <h5 class="light grey-text text-lighten-3">Para sua estadia !</h5>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col s12 m6 l6">
                        <div class="card z-depth-2 hoverable">
                            <div class="card-image">
                                <img  class="materialboxed" width="416" height="192" src="../../img/galeriaFotos/resplendor7.jpg">
                                <span class="card-title">Resplendor</span>
                            </div>
                            <div class="card-content">
                                <p>Resplendor é um município brasileiro no interior do estado de Minas Gerais,
                                    Região Sudeste do país. Pertence à Mesorregião do Vale do Rio Doce e Microrregião
                                    de Aimorés e localiza-se a leste da capital do estado, distando desta
                                    cerca de 440 km.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col s12 m6 l6">
                        <div class="card z-depth-2 hoverable">
                            <div class="card-image">
                                <img class="materialboxed" width="416" height="192" src="../../img/galeriaFotos/resplendor5.jpg">
                                <span class="card-title">Os Krenak</span>
                            </div>
                            <div class="card-content">
                                <p>Os Krenak pertencem ao grupo lingüístico Macro-Jê, falando uma língua
                                    denominada Borun. Por isso, entre eles, são denominados de Borun e os Borun
                                    do Watu são os Krenak de Resplendor, MG.
                                </p>
                                <br>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col s12 m6 l6">
                        <div class="card z-depth-2 hoverable">
                            <div class="card-image">
                                <img class="materialboxed" width="416" height="192" src="../../img/galeriaFotos/resplendor6.jpg">
                                <span class="card-title">Rio Doce</span>
                            </div>
                            <div class="card-content">
                                <p>O rio Doce é um curso de água da Região Sudeste do Brasil, que banha os estados de
                                    Minas Gerais e Espírito Santo. Com cerca de 853 km de extensão, seu curso representa
                                    a mais importante bacia hidrográfica totalmente incluída na Região Sudeste.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col s12 m6 l6">
                        <div class="card z-depth-2 hoverable">
                            <div class="card-image">
                                <img class="materialboxed" width="416" height="192" src="../../img/galeriaFotos/resplendor4.jpg">
                                <span class="card-title">Cultura</span>
                            </div>
                            <div class="card-content">
                                <p>
                                    Festa Rural de Resplendor, realizada desde 1983, contando com exposições, cavalgadas e
                                    shows musicais com bandas regionais ou conhecidas nacionalmente, sendo que em algumas
                                    edições atrai mais de 20 mil pessoas durante os dias do evento.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col s12 m6 l6">
                        <div class="card z-depth-2 hoverable">
                            <div class="card-image">
                                <img class="materialboxed" width="416" height="192" src="../../img/galeriaFotos/seta-saloes-01.jpg">
                                <span class="card-title">Sete Salões</span>
                            </div>
                            <div class="card-content">
                                <p>O Parque Estadual Sete Salões é uma área bem conhecida na região por
                                    seus atrativos naturais, em especial a gruta arenítica, cujos salões
                                    podem ser percorridos e admirados em sua beleza!
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">

    export default {
        mounted(){
            $('nav div ul').children().removeClass('active');
            $('.nav-resp').addClass('active');

            $('.slider').slider();
            $('.materialboxed').materialbox();
        }
    };
</script>


// WEBPACK FOOTER //
// resplendor.vue?5eeecb9b